define("shared/utils/formatters/ig-post-from-graph", ["exports", "moment", "tracked-built-ins", "later/models/ig-post", "shared/utils/get-hashtags"], function (_exports, _moment, _trackedBuiltIns, _igPost, _getHashtags) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"moment",0,"tracked-built-ins",0,"later/models/ig-post",0,"shared/utils/get-hashtags"eaimeta@70e063a35619d71f

  function createIgPostFromGraph(igMedia, socialProfile) {
    let carouselMediaItems = igMedia.children ? igMedia.children.data : [];

    if (igMedia.children) {
      carouselMediaItems = igMedia.children.data.map(data => {
        const isVideo = data.media_type.toLowerCase() === 'video';
        return {
          mediaType: data.media_type.toLowerCase(),
          thumbUrl: data.media_url,
          id: data.id,
          captionText: igMedia.caption,
          link: igMedia.permalink,
          lowBandwidthVideoUrl: isVideo ? data.media_url : undefined,
          lowResVideoUrl: isVideo ? data.media_url : undefined,
          standardResVideoUrl: isVideo ? data.media_url : undefined,
          lowResUrl: data.media_url,
          highResUrl: data.media_url,
          standardResUrl: data.media_url
        };
      });
    }

    let thumbnail_url = igMedia.thumbnail_url || igMedia.media_url;

    if (igMedia.children && igMedia.children.data[0].media_url) {
      thumbnail_url = igMedia.children.data[0].media_url;
    }

    const isVideo = igMedia.media_type.toLowerCase() === 'video';
    const post = {
      caption: igMedia.caption,
      carouselMediaItems: new _trackedBuiltIns.TrackedArray(carouselMediaItems),
      createdTime: igMedia.timestamp ? (0, _moment.default)(igMedia.timestamp).unix() : undefined,
      commentCount: igMedia.comments_count,
      likeCount: igMedia.like_count,
      hasMedia: true,
      id: igMedia.id,
      isDeleted: igMedia.is_deleted || false,
      isGraph: true,
      isSelected: false,
      link: igMedia.permalink,
      mediaProductType: igMedia.media_product_type,
      tags: (0, _getHashtags.default)(igMedia.caption),
      timeCollected: Date.now(),
      type: igMedia.media_type.toLowerCase(),
      username: igMedia.username,
      videoTitle: igMedia.video_title,
      thumbUrl: thumbnail_url,
      lowResUrl: thumbnail_url,
      highResUrl: igMedia.media_url,
      standardResUrl: thumbnail_url,
      lowBandwidthVideoUrl: isVideo ? igMedia.media_url : undefined,
      lowResVideoUrl: isVideo ? igMedia.media_url : undefined,
      standardResVideoUrl: isVideo ? igMedia.media_url : undefined,
      socialProfile,
      igId: socialProfile ? igMedia.ig_id + '_' + socialProfile.get('uid') : undefined,
      userId: socialProfile?.get('uid'),
      userProfileUrl: socialProfile?.get('avatarUrl'),
      width: igMedia.width,
      height: igMedia.height,
      account: igMedia.account
    };
    return _igPost.default.create(post);
  }

  var _default = createIgPostFromGraph;
  _exports.default = _default;
});